// Hint list of well-known tool names. Not authoritative — the source of
// truth is the @edgevanta/agent-tools runtime registry. New tools can be
// added to the registry without updating this list or running a migration.
export const AGENT_TOOL_VALUES = [
  'searchFiles',
  'embeddingSearchFiles',
  'fetchFilePages',
  'codeInterpreter',
  'getDatabaseSchema',
  'queryDatabase',
  'generateArtifact',
] as const;

export type AgentTool = (typeof AGENT_TOOL_VALUES)[number];

export const AGENT_TOOL_LABELS: Record<AgentTool, string> = {
  searchFiles: 'Search Files',
  embeddingSearchFiles: 'Embedding Search Files',
  fetchFilePages: 'Fetch File Pages',
  codeInterpreter: 'Code Interpreter',
  getDatabaseSchema: 'Get Database Schema',
  queryDatabase: 'Query Database',
  generateArtifact: 'Generate Artifact',
};

export const AGENT_TOOL_CHOICE_BASE_VALUES = [
  'auto',
  'none',
  'required',
] as const;
export const AGENT_TOOL_CHOICE_VALUES = [
  ...AGENT_TOOL_CHOICE_BASE_VALUES,
  ...AGENT_TOOL_VALUES,
] as const;
export type AgentToolChoice = (typeof AGENT_TOOL_CHOICE_VALUES)[number];
